import React from 'react';
import { connect } from 'react-redux';

import { FavoritesEmptyState } from 'app/modules/Betting';
import ErrorBoundary from 'app/widgets/ErrorBoundary';

import { sports } from '../selectors/entities';
import { createFavoritesGridSelector } from '../selectors/gridPresentation';
import { SportsGrid } from './components/SportsGrid';

const Favorites = ({
  tournamentsBySportId,
  sports,
}) => {
  if (tournamentsBySportId.size === 0) {
    return (
      <ErrorBoundary>
        <FavoritesEmptyState />
      </ErrorBoundary>
    );
  }

  return (
    <SportsGrid tournamentsBySportId={tournamentsBySportId}
                sports={sports} />
  );
};

const createMapStateToProps = () => {
  const favoritesGridSelector = createFavoritesGridSelector();

  return (state) => ({
    tournamentsBySportId: favoritesGridSelector(state),
    sports: sports(state),
  });
};

export default connect(createMapStateToProps)(Favorites);
